import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ConnectionType } from '../../modal/handle-cpx-modal/handle-cpx-modal.component';
import { environment } from 'src/environments/environment';

export interface DmpAutorizationForm {
  autorization: 'explicite' | 'bris-de-glace' | 'refus' | boolean;
  brisDeGlaceReason?: string;
  alimentation?: boolean;
}

@Component({
  selector: 'app-dmp-access-request-modal',
  templateUrl: './dmp-access-request-modal.component.html',
  styleUrls: [
    './dmp-access-request-modal.component.scss',
    '../../modal/modal.fragment.scss'
  ]
})
export class DmpAccessRequestModalComponent implements OnInit, OnDestroy {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter<DmpAutorizationForm>();
  public patientName = '';
  public connectionType: ConnectionType;
  public connectionTypeCompare = ConnectionType;
  public formGroupCps: FormGroup;
  public formGroupCpe: FormGroup;
  public autorisationAlimentationDmp = false;
  public autorisationAccessDmp: 'explicite' | 'bris-de-glace' | 'refus' | undefined = undefined;
  private _formChangeSub: Subscription;
  private _autorizationPreviousValue = undefined

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroupCps = this._formBuilder.group({
      autorization: [this.autorisationAccessDmp],
      brisDeGlaceReason: [''],
      alimentation: [this.autorisationAlimentationDmp]
    });
    this._autorizationPreviousValue = this.autorisationAccessDmp;

    this.formGroupCpe = this._formBuilder.group({
      alimentation: ['']
    });

    this._formChangeSub = this.formGroupCps.get('autorization').valueChanges.subscribe((change) => {
      if (change === 'bris-de-glace') {
        this.formGroupCps.get('brisDeGlaceReason').setValue('');
        this.formGroupCps.get('brisDeGlaceReason').setValidators(Validators.required);
      } else {
        this.formGroupCps.get('brisDeGlaceReason').clearValidators();
      }
      this.formGroupCps.get('brisDeGlaceReason').updateValueAndValidity();
      this._autorizationPreviousValue = change;
    });
  }

  public autorizationClick(evt: PointerEvent): void {
    if ((evt?.target as any)?.value === this._autorizationPreviousValue) {
      this.formGroupCps.get('autorization').setValue(undefined);
      this.formGroupCps.get('autorization').updateValueAndValidity();
      this._autorizationPreviousValue = undefined;
    }
  }

  ngOnDestroy(): void {
    if (this._formChangeSub) {
      this._formChangeSub.unsubscribe();
    }
  }

  public confirmAutorization(): void {
    if ((this.connectionType === ConnectionType.cps || this.connectionType === ConnectionType.cpf) && this.formGroupCps.valid) {
      this.closeModal({
        autorization: this.formGroupCps.get('autorization').value,
        brisDeGlaceReason: this.formGroupCps.get('brisDeGlaceReason').value && this.formGroupCps.get('brisDeGlaceReason').value !== ''
          ? this.formGroupCps.get('brisDeGlaceReason').value
          : undefined,
        alimentation: this.formGroupCps.get('alimentation').value
      });
    } else if (this.connectionType === ConnectionType.cpe && this.formGroupCpe.valid) {
      this.closeModal({
        autorization: false,
        alimentation: this.formGroupCpe.get('alimentation').value
      });
    } else {
      this.closeModal();
    }
  }

  public closeModal(haveAutorisation?: DmpAutorizationForm): void {
    this.closeEmitter.emit(haveAutorisation);
  }

}
